import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidCameraPlusIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M23 2h-1V1c0-.6-.4-1-1-1s-1 .4-1 1v1h-1c-.6 0-1 .4-1 1s.4 1 1 1h1v1c0 .6.4 1 1 1s1-.4 1-1V4h1c.6 0 1-.4 1-1s-.4-1-1-1Zm-11 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm7-4h-1.3l-.3-.9c-.1-.3-.2-.5-.4-.8v-.1l-.1-.1c-.6-.7-1.4-1.1-2.3-1.1H9.4c-.5 0-1.1.2-1.5.5-.1 0-.1.1-.2.1-.5.4-.9.9-1.1 1.5l-.3.9H5c-1.7 0-3 1.3-3 3v8c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-8c0-1.7-1.3-3-3-3Zm-7 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4Z"/>
  </SvgIcon>
}

export default SolidCameraPlusIcon
